import React from "react";
import {SvgIcon, SvgIconProps, useTheme} from "@mui/material";

export function KurzLogo(props: SvgIconProps) {
  const theme = useTheme();

  return <SvgIcon {...props} fontSize={"large"} sx={{...props.sx, color: theme.palette.text.primary, width: 120, height: 30}}
                  viewBox="0 0 551.1 137.8">
    <g fill="currentColor" fillRule="evenodd">
      <g>
        <path d="M413.3,0v137.8h137.8V0H413.3z M546.6,133.3H417.7V4.5h128.9V133.3z"/>
        <path d="M534.8,30.7l0.4-9.1h3v-6.2h-42.9v6.2h3l0.3,9.1h-32v-4.4h-7.2v-11h-30.6v15.4H424v6.9
        	h4.7v8.9c0,5.1,2.5,9.6,6.8,12v56.4h62.1v7.8H536V73.2h-38.5l0,7.6L469,88.4l-9.3-31.1c3.5-1.6,6.8-6.3,6.8-10.9v-8.9h32.6l0,0
        	l0.7,22.7h33.8l0.7-22.7h3.9v-6.9L534.8,30.7L534.8,30.7z M435.4,21.6h16.8v4.7h-8.3v6h-8.4V21.6z M529.2,80v35.9h-24.9V80H529.2z
        	 M497.5,87.8V108h-55.3V53.3c-4,0-6.8-3.1-6.8-6.9v-7.6h13.2c4.6,0,8.6-2.5,10.1-6.4h0.6v14c0,3.8-1.7,6.9-7.9,6.9l13,43.4
        	L497.5,87.8z M526.6,54h-20l-1-32.5h22L526.6,54z"/>
      </g>
      <g>
        <polygon points="382.7,30.7 301,30.7 301,46.7 352.7,46.7 297.3,100.2 297.3,114.8 382.7,114.8 382.7,98.8 327.2,98.8
        		382.7,45.3"/>
        <path id="_x3C_Pfad_x3E__1_" d="M260.9,83.9c23-0.1,26.5-17.4,26.9-26.8c0.6-12.2-3.8-26.4-25.5-26.5h-62.7v84.2h22.8
        		V83.9h9.9l30.5,30.9h30.8L260.9,83.9z M252.7,67.9h-30.2V46.7h29c5.5,0,12.1,2.1,12.1,10.5C263.7,65.1,257.8,67.9,252.7,67.9z"/>
        <path d="M163.1,79c0,8.2-0.4,22.2-21.3,22.2c-21,0-21.3-13.9-21.3-22.2V30.7H97.8v54c0,9.4,1.2,32.5,44.1,32.5
        		s44.1-23.1,44.1-32.5v-54h-22.8V79z"/>
        <polygon points="92,30.7 61.5,30.7 22.8,72.6 22.8,30.7 0,30.7 0,114.8 22.8,114.8 22.8,72.9 64.2,114.8 95,114.8
        		50.3,72.7"/>
      </g>
    </g>
  </SvgIcon>;
}
